import Router from './router'
import { App as AntApp } from 'antd';
import 'antd/dist/reset.css';
import './style.scss'
import './index.css'

function AppRoot() {
    return (
      <AntApp>
        <Router/>
      </AntApp>
    );
}

export default AppRoot